import { combineReducers } from '@reduxjs/toolkit';

import loadingSlice from './loadingSlice';
import customMsgSlice from './customMsgSlice';
import commonSlice from './commonSlice';
import loginSlice from '../login/loginSlice';
import previousEmploymentSlice from '../previousEmployment/previousSlice';
import dialogSlice from './dialogSlice';
import dependentsSlice from '../dependents/dependentsSlice';

import insuranceSlice from '../deductions/insurancePremiums/insuranceSlice';
import itemSelectionSlice from '../deductions/itemSelection/itemSelectionSlice';
import medicalSlice from '../deductions/medicalExpenses/medicalSlice';
import educationSlice from '../deductions/educationExpenses/educationSlice';
import doncationSlice from '../deductions/donations/doncationSlice';
import creditCardsSlice from '../deductions/creditCards/creditCardsSlice';
import housingFundsSlice from '../deductions/housingFunds/housingFundsSlice';
import otherDeductionsSlice from '../deductions/otherDeductions/otherDeductionsSlice';
import eDocumentsSlice from '../eDocuments/eDocumentsSlice';
import evidenceDocumentsSlice from '../evidenceDocuments/evidenceDocumentsSlice';
import resultQuerySlice from '../resultQuery/resultQuerySlice';
import myInfoSlice from '../myInfo/myInfoSlice';
import findByPasswordSlice from '../findPassword/findByPasswordSlice';
import aiAssistantSlice from '../aiAssistant/aiAssistantSlice';

const RootReducer = {
  common: commonSlice,
  customMsg: customMsgSlice,
  loading: loadingSlice,
  dialog: dialogSlice, //alert
  login: loginSlice, //로그인
  findByPassword: findByPasswordSlice, //비밀번호찾기
  myInfo: myInfoSlice, //내정보
  previousEmployment: previousEmploymentSlice, //전직장
  dependents: dependentsSlice, //부양가족
  eDocuments: eDocumentsSlice, //전자문서
  itemSelection: itemSelectionSlice, //항목선택
  insurance: insuranceSlice, //보험
  medical: medicalSlice, //의료비
  education: educationSlice, //교육비
  donation: doncationSlice, //기부금
  creditCards: creditCardsSlice, //신용카드
  housingFunds: housingFundsSlice, //주택자금
  otherDeductions: otherDeductionsSlice, //기타공제
  evidenceDocuments: evidenceDocumentsSlice, //증빙서류
  resultQuery: resultQuerySlice, //결과조회
  aiAssistant: aiAssistantSlice, // AI 연말정산 세법 도우미
};

export default RootReducer;
